import { useAuthStore } from "@/store/useAuthStore";
export default {
  setup() {
    const store = useAuthStore();
    return {
      store
    };
  }
};